export default {
    name: 'root',
    path: '/',
    redirect: '/entrar',
}